import {
    AfterViewInit,
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    Injector,
    Input,
    Type,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';

import { WidgetConfiguration } from './config.widget.model';
import {
    CMPS_WIDGET_COMPONENT_CONFIG,
    CMPS_WIDGET_CONFIG,
    CMPS_WIDGET_OPTIONS,
} from './widget.metadata';

export interface WidgetComponentConfig {
    id: string;
    header: string;
    component: Type<any>;
    config?: WidgetConfiguration;
    options?: any;
    noEncapsulate?: boolean;
}

export function createComponent(
    component: Type<any>,
    resolver: ComponentFactoryResolver,
    providers: any[],
): ComponentRef<any> {
    const factory = resolver.resolveComponentFactory(component);
    const refInjector = Injector.create({ providers });
    return factory.create(refInjector);
}

@Component({
    selector: 'cmps-widget',
    templateUrl: './widget.component.html',
})
export class WidgetComponent implements AfterViewInit {
    @ViewChild('container', { read: ViewContainerRef })
    container: ViewContainerRef;

    @Input() config: WidgetComponentConfig;

    constructor(private readonly _resolver: ComponentFactoryResolver) {}

    ngAfterViewInit(): void {
        const componentRef = createComponent(
            this.config.component,
            this._resolver,
            [
                {
                    provide: CMPS_WIDGET_COMPONENT_CONFIG,
                    useValue: this.config,
                },
                {
                    provide: CMPS_WIDGET_CONFIG,
                    useValue: this.config.config,
                },
                {
                    provide: CMPS_WIDGET_OPTIONS,
                    useValue: this.config.options,
                },
            ],
        );
        setTimeout(() => this.container.insert(componentRef.hostView));
    }
}
